import { TLCEXT } from "../../../js/lib/ext/Ext";
import { ApplicationData } from "../ls2pac/ApplicationData";
import { LS2PAC_Utils } from "../ls2pac/utils/Utils";
import { ResourceUtils } from "../ls2pac/utils/resourceUtils";

export class AvailabilityFactory {
	constructor() { }
	/**
	 *
	 * @param {String} targetId
	 * @param {Object} resource
	 */
	static displayAvailability(targetId, resource) {

		var displayObject = this.getDisplayObject(resource);

		var templateData = '<span class="availability {availabilityClass}">{countToShow}{availability}</span>';

		switch (displayObject.availabilityType) {
			case this.availabilityType.hardcopy:
				if (ResourceUtils.showAvailabilityBranch(displayObject)) {
					templateData += ' <span class="availabilityLocation">{preLocationText} <strong>{branchText}</strong></span>';
				}
				if (ResourceUtils.showAvailabilityLink(displayObject)) {
					templateData += ' <span class="copiesLink">(<span class="link allCopies">{linkText}</span>)</span>';
				}
				break;
			case this.availabilityType.downloadable:
				templateData += ' <span class="downloadableHoldsInfo" {resourceUtil.showEResourceHoldings}>{downloadableHoldsText}</span>';
				if (!resource.hasDownloadbleCheckouts) {
					templateData += ' <span class="moreOptionsLink" {resourceUtil.showMoreOptionsLink}>(<span class="link moreOptions">{languageUtil.checkDigitalLocations}</span>)</span>';
				}
				break;
			case this.availabilityType.reserveCopy:
				templateData += ' <span class="availabilityLocation">{languageUtil.reservesAvailability_in} <strong>{languageUtil.reservesAvailability_reserves}</span>';
				if (ResourceUtils.showReservesAvailabilityLink(displayObject)) {
					templateData += ' <span class="moreOptionsLink">(<span class="link moreOptions">{linkText}</span>)</span>';
				}
				break;
			case this.availabilityType.serialCopy:
				if (ResourceUtils.showAvailabilityBranch(displayObject) && !displayObject.noCopies) {
					templateData += ' <span class="availabilityLocation">{preLocationText} <strong>{branchText}</strong></span>';
				}
				if (ResourceUtils.showAvailabilityLink(displayObject) && !displayObject.noCopies) {
					templateData += ' <span class="copiesLink">(<span class="link allCopies">{linkText}</span>)</span>';
				}
				break;
		}

		displayObject.hasDownloadbleCheckouts = resource.hasDownloadbleCheckouts;

		if (targetId !== undefined && targetId.length > 0) {
			var $target = $("#" + targetId);
			if ($target && $target.spin) {
				$target.spin(false);
				var template = TLCEXT.Template(templateData);
				$target.html(template.populate(displayObject)).show();
			}
		}

		return displayObject;
	}
	static getDisplayObject(resource) {

		resource.disableRequestButton = false;
		resource.showRequestButton = true;

		var displayObject = this.getBaseDisplayObject(resource);

		if (resource.link) {
			displayObject.link = resource.link;
		}

		//if this resource is a News Feed or contentDM then we don't need to go any further
		if (parseInt(resource.rtype, 10) !== 1) {
			displayObject.availabilityType = AvailabilityFactory.availabilityType.newsfeedOrContentDM;
			return displayObject;
		}

		//if this resource is downloadable then we don't need to go any further
		if (displayObject.downloadable) {
			return this.handleDownloadable(resource, displayObject);
		}

		if (displayObject.reserved) {
			return this.handleReserveCopy(resource, displayObject);
		}

		if (displayObject.serial) {
			return this.handleSerialCopy(resource, displayObject);
		}

		//we arent RSS/ContentDM or a downloadable resource so do this
		this.handleHardCopy(resource, displayObject);

		return displayObject;

	}
	static handleTooManyHoldingsToFetch(resource, displayObject) {
		displayObject.availability = "";
		displayObject.countToShow = "";
		displayObject.showBranch = false;
		resource.disableRequestButton = false;
		resource.holdingForOnShelf = null;
		displayObject.linkText = ApplicationData.language.availability_tooManyToFetchMessage;

		resource.showRequestButton = LS2PAC_Utils.showRequestButton(resource);
	}
	static handleHardCopy(resource, displayObject) {
		displayObject.availabilityType = AvailabilityFactory.availabilityType.hardcopy;

		if (resource.tooManyholdingsToFetch) {
			this.handleTooManyHoldingsToFetch(resource, displayObject);
			return displayObject;
		}

		this.applyLabelsForNoLocalBranchState(resource, displayObject);
		this.handleLimiting(resource, displayObject);

		var _currentBranch = ApplicationData.branchLimitsUtil.getCurrentBranchIfNotLimited();
		this.setAvailabilityCounts(resource, displayObject, _currentBranch);

		this.handleLabels(resource, displayObject, _currentBranch);

		return displayObject;
	}
	static handleSerialCopy(resource, displayObject) {
		displayObject.availabilityType = AvailabilityFactory.availabilityType.serialCopy;

		if (resource.tooManyholdingsToFetch) {
			this.handleTooManyHoldingsToFetch(resource, displayObject);
			return displayObject;
		}

		this.applyLabelsForNoLocalBranchState(resource, displayObject);
		this.handleLimiting(resource, displayObject);

		var _currentBranch = ApplicationData.branchLimitsUtil.getCurrentBranchIfNotLimited();
		this.setAvailabilityCounts(resource, displayObject, _currentBranch);

		this.handleLabels(resource, displayObject, _currentBranch);

		return displayObject;
	}
	static handleReserveCopy(resource, displayObject) {
		displayObject.availabilityType = AvailabilityFactory.availabilityType.reserveCopy;

		if (resource.tooManyholdingsToFetch) {
			this.handleTooManyHoldingsToFetch(resource, displayObject);
			return displayObject;
		}

		this.applyLabelsForNoLocalBranchState(resource, displayObject);
		this.handleLimiting(resource, displayObject);

		var _currentBranch = ApplicationData.branchLimitsUtil.getCurrentBranchIfNotLimited(true);

		// Strip holdings that are not reserved but store them
		var allHoldingsInformations = resource.holdingsInformations;
		resource.holdingsInformations = $.grep(resource.holdingsInformations, function (holding, index) {
			if (holding.reserved) {
				return true;
			}
		});

		// pass stripped resource
		this.setAvailabilityCounts(resource, displayObject, _currentBranch);

		this.handleLabels(resource, displayObject, _currentBranch);

		// All reserves will show this link text, regardless of status
		displayObject.linkText = ApplicationData.language.showAdditionalCopies;

		// Restore all the holdings for use in further locations (full details)
		resource.holdingsInformations = allHoldingsInformations;
		if (displayObject.totalReserves == resource.holdingsInformations.length) {
			displayObject.showLink = false;
		}

		return displayObject;
	}
	static handleLabels(resource, displayObject, _currentBranch) {
		var holdingsToCheck = resource.holdingsInformations.slice(0);

		var isLocalButNoCopies = false;

		//If we are local we have to base the availability solely on the local copies
		if (_currentBranch != null) {
			displayObject.count = displayObject.localCount;
			displayObject.total = displayObject.localCopies;
			displayObject.nonCirculatingCount = displayObject.localNonCirculatingCount;
			displayObject.onOrderCount = displayObject.localOnOrderCount;

			isLocalButNoCopies = displayObject.localCopies == 0;
			holdingsToCheck = $.grep(resource.holdingsInformations,
				function (holding, index) {
					return holding.branchIdentifier == _currentBranch;
				});

			displayObject.preLocationText = ApplicationData.language.availability_at;
			displayObject.linkText = ApplicationData.language.availability_checkOtherLocations;

			if (displayObject.branchText == "") {
				displayObject.showBranch = true;
				displayObject.showLink = true;
				displayObject.branchText = ApplicationData.branchLimitsUtil.getBranchNameById(_currentBranch);
			}
		}

		if (displayObject.reserved) {
			displayObject.totalReserves = $.grep(holdingsToCheck,
				function (holding, index) {
					return (holding.reserved);
				}).length;
		}


		var totalWithAvailability = $.grep(holdingsToCheck,
			function (holding, index) {
				return (holding.available !== undefined
				);
			}).length;


		var nonCircAndAvailable = $.grep(holdingsToCheck,
			function (holding, index) {
				return ((holding.available
				) && (holding.nonCirculating
					)
				) || holding.available == undefined;
			}).length;

		//var legitAvailableCopies = LS2PAC_Utils.getLegitAvailableCopiesLength(holdingsToCheck);
		var onOrderAndNonCirc = $.grep(holdingsToCheck,
			function (holding, index) {
				return (holding.onOrder
				) && (holding.nonCirculating == false
					);
			}).length;

		displayObject.forceNonCirc = (nonCircAndAvailable + onOrderAndNonCirc == displayObject.total);

		if (displayObject.count > 0) {
			this.setResourceAsAvailable(resource, displayObject);
		} else {
			this.setResourceAsNotAvailable(resource, displayObject);
		}

		resource.showRequestButton = LS2PAC_Utils.showRequestButton(resource);

		displayObject.noCopies = holdingsToCheck.length === 0;

		if ((displayObject.noCopies || isLocalButNoCopies) && resource.tooManyholdingsToFetch == false) {
			this.setResourceAsNoCopies(resource, displayObject, _currentBranch, isLocalButNoCopies);
		} else if (displayObject.onOrderCount == totalWithAvailability && isLocalButNoCopies == false) {
			this.setResourceAsOnOrder(resource, displayObject);
		} else if (((displayObject.nonCirculatingCount == totalWithAvailability && (displayObject.onOrderCount < totalWithAvailability))
			|| displayObject.forceNonCirc) && isLocalButNoCopies == false) {

			this.setResourceAsNonCirc(resource, displayObject, totalWithAvailability);
		}
	}
	static applyLabelsForNoLocalBranchState(resource, displayObject) {
		displayObject.preLocationText = ApplicationData.language.availability_in;
		displayObject.branchText = ApplicationData.language.availability_allLocations;
		displayObject.linkText = ApplicationData.language.availability_viewAllLocations;
	}
	static handleLimiting(resource, displayObject) {
		if (ApplicationData.branchLimitsUtil.getIsLimiting()) {
			displayObject.showBranch = false;
			displayObject.linkText = ApplicationData.language.availability_viewSelectedLocations;
		}
	}
	static setResourceAsAvailable(resource, displayObject) {
		displayObject.availability = ApplicationData.language.available;
		displayObject.availabilityClass = "available";
		displayObject.countToShow = displayObject.count + " ";
		resource.displayCollectionAndCall = true; //TODO: KOS - Is this used anywhere?
	}
	static setResourceAsNotAvailable(resource, displayObject) {
		displayObject.availability = ApplicationData.language.notAvailable;
		displayObject.availabilityClass = "not_available";
		// LSWEB-3436 : changed code to add in on shelf locations for all items when user branch is known
		// resource.holdingForOnShelf = null;
	}
	static setResourceAsNoCopies(resource, displayObject, _currentBranch, isLocalButNoCopies) {
		resource.disableRequestButton = true; //TODO this is also redundant, it is being set in showRequestButton based on displayObject.total
		displayObject.availability = ApplicationData.language.noCopies;
		displayObject.availabilityClass = "no_copies";
		displayObject.countToShow = "";

		resource.holdingForOnShelf = null;

		if (displayObject.noCopies && displayObject.serial) {
			displayObject.availability = ApplicationData.language.serialMessage;
		}
		if (displayObject.noCopies) {
			displayObject.showLink = false;
			displayObject.branchText = ApplicationData.language.availability_allLocations;
		}
		if (isLocalButNoCopies && resource.holdingsInformations.length > 0) {
			resource.disableRequestButton = false;
			displayObject.showLink = true;
			displayObject.branchText = ApplicationData.branchLimitsUtil.getBranchNameById(_currentBranch);
		}
	}
	static setResourceAsOnOrder(resource, displayObject) {
		displayObject.availability = ApplicationData.language.onOrder;
		displayObject.availabilityClass = "on_order";
		// LSWEB-3436 : changed code to add in on shelf locations for all items when user branch is known
		// resource.holdingForOnShelf = null;
	}
	static setResourceAsNonCirc(resource, displayObject, totalWithAvailability) {
		if (displayObject.nonCirculatingCount == totalWithAvailability) { //TODO, am I missing here?
			resource.disableRequestButton = true;
		}
		displayObject.availability = ApplicationData.language.nonCirculating;
		displayObject.availabilityClass = "non_circulating";
	}
	static getBaseDisplayObject(resource) {
		return {
			total: (resource.holdingsInformations) ? resource.holdingsInformations.length : 0,
			count: 0,
			localCount: 0,
			localCopies: 0,
			nonCirculatingCount: 0,
			localNonCirculatingCount: 0,
			onOrderCount: 0,
			localOnOrderCount: 0,
			nonCirculating: false,
			onOrder: false,
			showBranch: true,
			showLink: true,
			showMoreOptions: false,
			showEResourceHoldings: false,
			countToShow: "",
			availabilityClass: "",
			downloadable: resource.downloadable,
			reserved: resource.reserved || false,
			serial: resource.serial || false
		};
	}
	static setAvailabilityCounts(resource, displayObject, _currentBranch) {
		var hasBranchOrThereIsOnlyOneLocation = _currentBranch;
		if (ApplicationData.locationConfiguration.isLocationKnown()) {
			hasBranchOrThereIsOnlyOneLocation = true;
		}
		$.each(resource.holdingsInformations, function (index, holding) {
			if (holding.available == true) {
				displayObject.count += 1;
				if (_currentBranch == holding.branchIdentifier) {
					displayObject.localCount += 1;
				}
				if (!resource.holdingForOnShelf && hasBranchOrThereIsOnlyOneLocation) {
					resource.holdingForOnShelf = holding;
				}
			}
			if (holding.nonCirculating) {
				displayObject.nonCirculatingCount += 1;
				if (_currentBranch == holding.branchIdentifier) {
					displayObject.localNonCirculatingCount += 1;
				}
				if (!resource.holdingForOnShelf && hasBranchOrThereIsOnlyOneLocation) {
					resource.holdingForOnShelf = holding;
				}
			}
			if (holding.onOrder) {
				displayObject.onOrderCount += 1;
				if (_currentBranch == holding.branchIdentifier) {
					displayObject.localOnOrderCount += 1;
				}

			}
			if (holding.available === undefined) {
				displayObject.availability = ApplicationData.language.unknown;
				displayObject.availabilityClass = ApplicationData.language.unknown;
			}
			if (_currentBranch == holding.branchIdentifier) {
				displayObject.localCopies += 1;
				displayObject.branchText = holding.branchName;
			}
		});

		if (!resource.holdingForOnShelf && hasBranchOrThereIsOnlyOneLocation && (resource.holdingsInformations.length > 0)) {
			var holdingsToUse = $.grep(resource.holdingsInformations, function (holding, index) {
				return (holding.branchIdentifier == _currentBranch);
			});
			if (holdingsToUse.length > 0) {
				resource.holdingForOnShelf = holdingsToUse[0];
			} else {
				resource.holdingForOnShelf = resource.holdingsInformations[0];
			}
		}
	}
	static handleDownloadable(resource, displayObject) {
		displayObject.availabilityType = AvailabilityFactory.availabilityType.downloadable;
		displayObject.availabilityClass = "downloadable";
		displayObject.availability = ApplicationData.language.downloadable;
		displayObject.downloadableHoldsText = "";

		displayObject.showMoreOptions = false;
		displayObject.showLink = false;

		if (resource.eAvailabilities && resource.eAvailabilities.length > 0) {
			var eAvailabilitiesThatAreAvailable = $.grep(resource.eAvailabilities, function (eAvailability) {
				return eAvailability.availability;
			});

			var eAvailability = null;

			resource.availability = true;

			//if we NONE available or MORE than one, we should display the result of the PREFERRED availability
			if (eAvailabilitiesThatAreAvailable.length == 0 || eAvailabilitiesThatAreAvailable.length > 1) {
				//we will default to the first thing in the list in case there is nothing set preferred
				eAvailability = resource.eAvailabilities[0];
				resource.availability = eAvailability.availability;
				$.each(resource.eAvailabilities, function (index, currentAvailability) {
					if (currentAvailability.preferred) {
						eAvailability = currentAvailability;
						//we return false to ensure we only use the first thing marked preferred
						return false;
					}
				});
			} else {
				eAvailability = eAvailabilitiesThatAreAvailable[0];
			}
			if (eAvailability != null) {
				if (eAvailability.downloadLink) {
					displayObject.link = eAvailability.downloadLink;
					resource.link = eAvailability.downloadLink;
				} else {
					displayObject.link = resource.link;
				}

				resource.hasDownloadbleCheckouts = false;
				resource.eResourceHasAvailability = eAvailability.availability;
				resource.canCheckout = eAvailability.canCheckout;
				resource.actionsEnabled = eAvailability.actionsEnabled;
				if (eAvailability.canCheckout && eAvailability.actionsEnabled) {
					resource.hasDownloadbleCheckouts = true;
					resource.eResourceService = eAvailability.service;
					resource.eResourceId = eAvailability.itemId;
					resource.eResourceFormats = [];
					if (eAvailability.formatInfo && eAvailability.formatInfo.length > 0) {
						$.each(eAvailability.formatInfo, function (index, value) {
							value.formatName = value.formatId;

							if (value.formatToken && value.formatToken != "<InvalidEResourceFormat>") {
								value.formatName = ResourceUtils.getMessageByMessageTokenString(value.formatToken);
							}

							resource.eResourceFormats.push(value);
						});
					}
				}


				var borrowerLabel = ApplicationData.language.borrowers;
				var copiesLabel = ApplicationData.language.copies;
				if (eAvailability.availability == false) {
					displayObject.showEResourceHoldings = true;
					displayObject.showMoreOptions = true;
					displayObject.availabilityClass = "not_available";
					displayObject.availability = ApplicationData.language.notAvailable_download;

					//				if(resource.hasDownloadbleCheckouts == false) {
					//					resource.disableRequestButton = true;
					//				}
					if (eAvailability.preRelease) {
						displayObject.downloadableHoldsText = ApplicationData.language.preReleaseMessage + " " + eAvailability.releaseDate;
					} else {
						if (eAvailability.numberOfHolds == 1 || eAvailability.numberOfHolds == null) {
							borrowerLabel = ApplicationData.language.borrower;
						}
						if (eAvailability.copiesOwned == 1) {
							copiesLabel = ApplicationData.language.copy;
						}

						displayObject.downloadableHoldsText = eAvailability.numberOfHolds + " " + borrowerLabel + " " + ApplicationData.language.availability_waitingOn + " " + eAvailability.copiesOwned + " " + copiesLabel;
					}
				} else {
					if (eAvailability.alwaysAvailable) {
						displayObject.availability = ApplicationData.language.alwaysAvailable_download;
					} else {
						displayObject.availability = eAvailability.copiesAvailable + " " + ApplicationData.language.available_download;
					}
					displayObject.availabilityClass = "available";
				}
			}

		}

		resource.showRequestButton = true;
		displayObject.showBranch = false;

		return displayObject;
	}
}



/**
 *
 * @enum
 */
AvailabilityFactory.availabilityType = {
	newsfeedOrContentDM: "newsfeedOrContentDM",
	downloadable:        "downloadable",
	hardcopy:            "hardcopy",
	reserveCopy:         "reserveCopy",
	serialCopy:          "serialCopy"
};

















